/**
 * @file newPerson.ts
 * @brief The people rule (B48, DES 02-11-2026): someone new in VERBLIZR =
 *        a name AND a valid email. Checked here before the server's own
 *        EMAIL_REQUIRED / EMAIL_INVALID / NAME_REQUIRED / NAME_TOO_LONG.
 *
 * No imports: node:test runs it directly (newPerson.test.ts).
 *
 * @author DES
 * @date 02-11-2026
 */

export const FULL_EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** The first problem with a new person, or null. With `accountName` (the
 *  email is a VERBLIZR account) no typed name is needed: theirs is used. */
export function newPersonError(
  p: { name: string; email: string },
  accountName?: string | null,
): string | null {
  const email = p.email.trim();
  if (!email) return "Enter their email.";
  if (!FULL_EMAIL_RE.test(email)) return "That email doesn't look right.";
  if (!accountName && !p.name.trim()) return "Enter their name.";
  if (p.name.trim().length > 120) return "That name is too long.";
  return null;
}
